import { toast } from "react-toastify";
import { ExchangeOrder } from "../../Services/MainServices";

export const EXCHANGE_ORDER_REQUEST = "EXCHANGE_ORDER_REQUEST";
export const EXCHANGE_ORDER_SUCCESS = "EXCHANGE_ORDER_SUCCESS";
export const EXCHANGE_ORDER_FAILURE = "EXCHANGE_ORDER_FAILURE";

export const exchangeOrder = async (dispatch, data) => {
  dispatch({ type: EXCHANGE_ORDER_FAILURE });

  try {
    const response = await ExchangeOrder(data);
    if (response.status === 200) {
      dispatch({ type: EXCHANGE_ORDER_SUCCESS, payload: response.data.data });
      toast.success("Exchange Requested!");
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    dispatch({ type: EXCHANGE_ORDER_FAILURE, error: error.message });
    toast.error("Failed to request exchange!");
    throw new Error("Failed to request exchange", error);
  }
};
